import { styles } from './template.scss';
import { styles as commonStyles } from '../../../assets/common.scss';
import { styles as colorHelpersStyles } from '../../../assets/color-helpers.scss';

export const templateXdrSearchLive = document.createElement('template');

templateXdrSearchLive.innerHTML = `
  <style>${commonStyles}</style>
  <style>${colorHelpersStyles}</style>
  <style>${styles}</style>
  <gz-push-body-layout resizable="right">
    <div slot="push-body-sidenav">
      <gz-generic-grid-smart-views class="hidden" id="smart-views" hasSearchInput="true" />
      <div class="loader" id="loader">
        <gz-loader rows="4" class="smartview-loader"></gz-loader>
      </div>
    </div>
    <div slot="push-body-sidenav-title">
      <gz-title id="smart-views-title" fontweight="600" fontsize="11"></gz-title>
    </div>
    <div class="wrapper" slot="push-body-content">
      <gz-xdr-live-search-query-panel />
    </div>
  </gz-push-body-layout>
`;
